// pages/admin/OcrReview.js

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Stack,
  Chip,
  CircularProgress,
} from "@mui/material";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

export default function OcrReview() {
  const [pending, setPending] = useState([]);
  const [selected, setSelected] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const snap = await getDocs(collection(db, "ocrFailures"));
      const data = snap.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((d) => !d.reviewed);
      setPending(data);
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleSelect = (type, line) => {
    setSelected((prev) => ({ ...prev, [type]: line }));
  };

  const handleSave = async (item) => {
    const ref = doc(db, "ocrFailures", item.id);
    await updateDoc(ref, {
      reviewed: true,
      selectedTotal: selected.total,
      selectedSubtotal: selected.subtotal,
      selectedVAT: selected.vat,
    });
    setPending((prev) => prev.filter((r) => r.id !== item.id));
    setSelected({});
  };

  if (loading) return <CircularProgress sx={{ m: 4 }} />;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        🧠 OCR Review Panel
      </Typography>

      {pending.map((item) => (
        <Paper key={item.id} sx={{ p: 2, mb: 3, display: "flex", gap: 4 }}>
          <img
            src={item.imageUrl}
            alt="Receipt"
            style={{ width: 200, borderRadius: 4 }}
          />
          <Box>
            <Typography variant="subtitle1">{item.fileName}</Typography>
            <Typography variant="body2" gutterBottom>
              Vendor guess: {item.vendorGuess}
            </Typography>
            <Stack spacing={1}>
              {item.extractedLines.map((line, idx) => (
                <Chip
                  key={idx}
                  label={line}
                  onClick={() => {
                    if (line.includes("VAT")) handleSelect("vat", line);
                    else if (line.toLowerCase().includes("sub"))
                      handleSelect("subtotal", line);
                    else handleSelect("total", line);
                  }}
                  variant={
                    line === selected.total ||
                    line === selected.vat ||
                    line === selected.subtotal
                      ? "filled"
                      : "outlined"
                  }
                  color={
                    line === selected.total
                      ? "success"
                      : line === selected.vat
                      ? "warning"
                      : line === selected.subtotal
                      ? "primary"
                      : "default"
                  }
                />
              ))}
            </Stack>
            <Button
              variant="contained"
              sx={{ mt: 2 }}
              onClick={() => handleSave(item)}
              disabled={!selected.total}
            >
              ✅ Save Mapping
            </Button>
          </Box>
        </Paper>
      ))}
    </Box>
  );
}
